'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _rect = require('../../../common/maths/geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _rafThrottle = require('../../../common/utils/lib/rafThrottle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _elementUtil = require('../../element/elementUtil');

var _selectionActions = require('../../element/selection/selectionActions');

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Actions


// Components


// Selectors


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchSetSelectedElements: function dispatchSetSelectedElements(ids) {
            return dispatch((0, _selectionActions.setSelectedElements)({ ids: ids }));
        },
        dispatchAddSelectedElements: function dispatchAddSelectedElements(ids) {
            return dispatch((0, _selectionActions.addSelectedElements)({ ids: ids }));
        },
        dispatchRemoveSelectedElements: function dispatchRemoveSelectedElements(ids) {
            return dispatch((0, _selectionActions.removeSelectedElements)({ ids: ids }));
        },
        dispatchDeselectAllElements: function dispatchDeselectAllElements(ids) {
            return dispatch((0, _selectionActions.deselectAllElements)({ ids: ids }));
        }
    };
};

var MARQUEE_SELECTION_CLASS = 'marquee-selected';
/**
 * PERFORMANCE:
 * The following functions use vanilla JS to add classes to hovered elements for performance reasons.
 * 1. This prevents dispatching store state changes every time an element is hovered (thus preventing many re-renders
 *      or prop recalculations).
 * 2. Actually selecting elements causes their order in the DOM to change (due to the sorting of elements on the
 *      canvas), thus selecting and deselecting elements causes reasonably significant DOM changes in a small amount
 *      of time.  By using classes instead minimal DOM changes are required and instead of relying on React to
 *      perform reconciliation the browser only has to perform style & paint recalculations.
 */
var modifySelectionMarqueeClass = function modifySelectionMarqueeClass(modificationType) {
    return function (elementIds) {
        elementIds.forEach(function (id) {
            var canvasElement = document.getElementById((0, _elementUtil.getDomElementId)(id));
            if (!canvasElement) return;

            canvasElement.classList[modificationType](MARQUEE_SELECTION_CLASS);
        });
    };
};

var addSelectionMarqueeHoveredClass = modifySelectionMarqueeClass('add');
var removeSelectionMarqueeHoveredClass = modifySelectionMarqueeClass('remove');

var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(state)
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _dec2, _class;

    var SelectionMarqueeSelectedElementFinderDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
        _inherits(SelectionMarqueeSelectedElementFinderDecorator, _React$Component);

        function SelectionMarqueeSelectedElementFinderDecorator(props) {
            _classCallCheck(this, SelectionMarqueeSelectedElementFinderDecorator);

            var _this = _possibleConstructorReturn(this, (SelectionMarqueeSelectedElementFinderDecorator.__proto__ || Object.getPrototypeOf(SelectionMarqueeSelectedElementFinderDecorator)).call(this, props));

            _this.findHoveredElements = function (_ref) {
                var top = _ref.top,
                    left = _ref.left,
                    width = _ref.width,
                    height = _ref.height,
                    measurements = _ref.measurements;
                var _this$props = _this.props,
                    canvasElementIds = _this$props.canvasElementIds,
                    active = _this$props.active;

                if (!active || !width || !height) return;

                var marqueeRect = rectLib.getRect({ x: left, y: top, width: width, height: height });

                var currentHoveredElements = measurements.filter(function (elementMeasurement, elementId) {
                    if (!canvasElementIds.some(function (elId) {
                        return elId === elementId;
                    })) return false;

                    var elementRect = rectLib.getRect({
                        x: elementMeasurement.get('left'),
                        y: elementMeasurement.get('top'),
                        width: elementMeasurement.get('width'),
                        height: elementMeasurement.get('height')
                    });
                    return rectLib.isOverlapping(elementRect, marqueeRect);
                });

                var currentHoveredElementIds = (0, _immutableHelper.toIdArray)(currentHoveredElements);

                var noLongerHovered = (0, _lodash.difference)(_this.hoveredElementIds, currentHoveredElementIds);
                var newHovered = (0, _lodash.difference)(currentHoveredElementIds, _this.hoveredElementIds);

                if (newHovered.length || noLongerHovered.length) {
                    _this.hoveredElementIds = currentHoveredElementIds;
                    addSelectionMarqueeHoveredClass(newHovered);
                    removeSelectionMarqueeHoveredClass(noLongerHovered);
                }
            };

            _this.throttledFindHoveredElements = (0, _rafThrottle2.default)(_this.findHoveredElements);

            _this.startMarqueeSelect = function (args) {
                var appendMode = args.appendMode;
                var _this$props2 = _this.props,
                    dispatchDeselectAllElements = _this$props2.dispatchDeselectAllElements,
                    startMarqueeSelect = _this$props2.startMarqueeSelect;


                if (!appendMode) {
                    dispatchDeselectAllElements();
                }

                return startMarqueeSelect(args);
            };

            _this.finishMarqueeSelect = function () {
                var _this$props3 = _this.props,
                    finishMarqueeSelect = _this$props3.finishMarqueeSelect,
                    dispatchSetSelectedElements = _this$props3.dispatchSetSelectedElements,
                    dispatchAddSelectedElements = _this$props3.dispatchAddSelectedElements,
                    appendMode = _this$props3.appendMode;


                _this.throttledFindHoveredElements.cancel();

                removeSelectionMarqueeHoveredClass(_this.hoveredElementIds);

                appendMode ? dispatchAddSelectedElements(_this.hoveredElementIds) : dispatchSetSelectedElements(_this.hoveredElementIds);

                _this.hoveredElementIds = [];
                return finishMarqueeSelect.apply(undefined, arguments);
            };

            _this.hoveredElementIds = [];
            return _this;
        }

        _createClass(SelectionMarqueeSelectedElementFinderDecorator, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.active) {
                    this.throttledFindHoveredElements(nextProps);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttledFindHoveredElements.cancel();
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props,
                    measurements = _props.measurements,
                    rest = _objectWithoutProperties(_props, ['measurements']); // eslint-disable-line no-unused-vars


                return _react2.default.createElement(DecoratedComponent, _extends({}, rest, {
                    finishMarqueeSelect: this.finishMarqueeSelect,
                    startMarqueeSelect: this.startMarqueeSelect }));
            }
        }]);

        return SelectionMarqueeSelectedElementFinderDecorator;
    }(_react2.default.Component)) || _class) || _class);


    SelectionMarqueeSelectedElementFinderDecorator.propTypes = {
        canvasElementIds: _propTypes2.default.array.isRequired,
        dispatchSetSelectedElements: _propTypes2.default.func,
        dispatchAddSelectedElements: _propTypes2.default.func,
        dispatchRemoveSelectedElements: _propTypes2.default.func,
        dispatchDeselectAllElements: _propTypes2.default.func,
        startMarqueeSelect: _propTypes2.default.func,
        finishMarqueeSelect: _propTypes2.default.func,
        measurements: _propTypes2.default.object,
        active: _propTypes2.default.bool,
        appendMode: _propTypes2.default.bool,
        top: _propTypes2.default.number,
        left: _propTypes2.default.number,
        width: _propTypes2.default.number,
        height: _propTypes2.default.number
    };

    return SelectionMarqueeSelectedElementFinderDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/selection/selectionMarqueeSelectedElementFinderDecorator.js
// module id = 1697
// module chunks = 0